export class TravelArticleAuthor {
  /**
   * Author name
   */
  name: string;

  /**
   * Author title
   */
  title: string;

  static parse(data: any): TravelArticleAuthor {
    return {
      name: data.Name,
      title: data.Title
    };
  }
}
